import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {MyReferralsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {pageTitle} = translations['pt-br'].privateFlow.myReferrals;

export function ReferralsFlow() {
	const navigate = useNavigate();

	const handleBack = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	return (
		<PageWrapperLayout title={pageTitle}>
			<MainHeader
				dataTagId={{
					backButton: MyReferralsTaggingEnum.CLICK_VOLTAR_MEUS_ENCAMINHAMENTOS,
					closeButton: MyReferralsTaggingEnum.CLICK_FECHAR_MEUS_ENCAMINHAMENTOS,
				}}
				title={pageTitle}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute"></MainHeader>
		</PageWrapperLayout>
	);
}
